<script setup lang="ts">
import { useUxData } from '@/stores/ux-data';
import SourceFilterControl from '@/components/atoms/element-filters/SourceFilterControl.vue';
import WorldFilterControl from '@/components/atoms/element-filters/WorldFilterControl.vue';

// The Source + World filter pair every guided-setup picker step offers, worded identically: the
// steps just drop this into their filter bar. The counterpart of CharacterSourceFilter.vue,
// which does the same for the character editor's finders.
//
// Which drafts get the World control is the picker's rule, not this component's: the step passes
// `showWorld` from useGuidedElementPicker's showWorldFilter (worldless drafts only — see the
// comment there for the source-vs-world distinction; the Ancestry step, which fetches by hand,
// computes the same rule itself). WorldFilterControl additionally hides itself from users who
// cannot select a world.
//
// Two root nodes on purpose: the filter bar lays its slot out as a flex row, and a wrapper
// element would turn the pair into a single item.
defineProps<{ showWorld: boolean }>();
const ux = useUxData();
</script>

<template>
  <SourceFilterControl
    :label="ux.labels?.filters?.source?.chip ?? 'Source'"
    :placeholder="ux.labels?.filters?.source?.placeholder ?? 'World'"
  />
  <WorldFilterControl
    v-if="showWorld"
    :label="ux.labels?.filters?.world?.chip ?? 'World'"
    :placeholder="ux.labels?.filters?.world?.placeholder ?? 'World'"
  />
</template>
